// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  height: 168px;
  background: #fff;
}
ion-grid ion-col {
  display: flex;
  justify-content: center;
  align-items: center;
}
ion-grid ion-col img {
  max-height: 136px;
}

@media screen and (min-width: 700px) {
  ion-grid ion-col img {
    width: calc(100vw - 45%);
    max-width: 418px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/banner/banner.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;AACF;AAAE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEJ;AADI;EACE,iBAAA;AAGN;;AAEA;EAGM;IACE,wBAAA;IACA,gBAAA;EADN;AACF","sourcesContent":["ion-grid {\n  height: 168px;\n  background: #fff;\n  ion-col {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    img {\n      max-height: 136px;\n    }\n  }\n}\n\n@media screen and (min-width: 700px) {\n  ion-grid {\n    ion-col {\n      img {\n        width: calc(100vw - 45%);\n        max-width: 418px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
